import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';
import { CoreEnums } from '@/utils/domain/constants';
import { connectionTypeIcons } from './constants';

const TypeFilter = {
  ...Filters.BaseFilters.EnumFilter,
  name: 'type',
  label: 'global.type',
  enumNamespace: getEnumNamespace(CoreEnums.ConnectionType, 'Connections'),
  enumSource: CoreEnums.ConnectionType,
  options: createEnumOptions(CoreEnums.ConnectionType, 'connections.type'),
  iconMap: connectionTypeIcons,
  allowSearch: true,
  showSearch: true,
};

// Use the access-aware `connection/groups` endpoint so the dropdown
// only surfaces folders the current user can see. The administrative
// CRUD endpoint `connectionGroup/paged` is reserved for the legacy
// `/connections/groups` configuration page. Same pattern applied to
// lists/reports/entities/agents.
const GroupFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'groupId',
  label: 'global.text.group',
  apiRoute: 'connection/groups',
  params: { select: 'id,name', orderBy: 'name asc' },
};

const OwnerFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'ownerUserId',
  label: 'connections.text.ownerUser',
  apiRoute: 'user/paged',
  params: { select: 'id,fullName', orderBy: 'fullName asc' },
};

const IsPublicFilter = {
  ...Filters.BaseFilters.BooleanFilter,
  name: 'isPublic',
  label: 'global.text.isPublic',
};

const ValidatedFilter = {
  ...Filters.BaseFilters.BooleanFilter,
  name: 'validated',
  label: 'global.text.validated',
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
  defaultValue: CoreEnums.FilterDateRange.Disabled,
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
  defaultValue: CoreEnums.FilterDateRange.Disabled,
};

export const filtersConfig = [
  TypeFilter,
  GroupFilter,
  OwnerFilter,
  IsPublicFilter,
  ValidatedFilter,
  Filters.IsActiveFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
];

registerModuleFilters('connections', [TypeFilter]);
